import React from 'react';
import styles from './styles.module.scss';

const Spacer = () => {
  return <div className={styles.spacer} />;
};

export default Spacer;
